<div class="home-container" [class.chat-active]="isChatMode">
  <!-- Welcome Section -->
  <div class="welcome-section" *ngIf="!isChatMode">
    <h1 class="welcome-title">
      <span class="animated-text" dir="ltr">{{ animatedWelcomeText }}</span>
      <span class="cursor" *ngIf="isAnimating">|</span>
    </h1>
    <p class="welcome-subtitle">
      search for engineering work orders, CES documents, or ask general engineering questions
    </p>
  </div>

  <!-- Chat Interface - (when chat active) -->
  <app-chat-interface
    [chatMessages]="chatMessages"
    [isLoading]="isLoading"
    [drtProgress]="drtProgress"
    [suggestionsDisabled]="suggestionsDisabled"
    (feedbackSubmitted)="onFeedbackSubmitted($event)"
    (feedbackDialogStateChanged)="onFeedbackDialogStateChanged($event)"
    (drtGenerateRequested)="onDrtGenerateRequested($event)"
    (ewoShowMoreRequested)="onEwoShowMoreRequested($event)"
    (suggestionClicked)="onSuggestionClicked($event)"
  ></app-chat-interface>

  <!-- Chat Input -->
  <div class="chat-input-wrapper" [class.chat-mode]="isChatMode" [class.disabled]="feedbackDialogOpen">
    <app-chat-input
      [promptText]="promptText"
      [promptPlaceholder]="promptPlaceholder"
      [fileUploadEnabled]="isFileUploadEnabled"
      [selectedFiles]="selectedFiles"
      [disabled]="feedbackDialogOpen"
      [isChatMode]="isChatMode"
      (promptChange)="onPromptChange($event)"
      (fileSelected)="onFileSelected($event)"
      (fileRemoved)="removeFile($event)"
      (submitMessage)="onSubmit()"
    ></app-chat-input>
  </div>

  <div class="chat-disclaimer" *ngIf="isChatMode">
    AI-generated content may be incorrect
  </div>

  <!-- Example Questions -->
  <app-example-questions
    *ngIf="!isChatMode"
    (questionSelected)="onQuestionClick($event)"
  ></app-example-questions>
</div>
